module.exports = __webpack_public_path__ + "assets/img/146501.183c45bc.png";